export default __webpack_public_path__ + "static/media/James Thomas Davey - Resume.b6e10fc6.pdf";